// extracted by mini-css-extract-plugin
export default {"taskNew":"Form_taskNew__OA1cC","inputContainer":"Form_inputContainer__70GgF"};